import {
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from '@mui/material';
import api from 'services/api';
import { Image, PictureAsPdf } from '@mui/icons-material';
import cn from 'utils/cn';
import { produce } from 'immer';
import useAppStore from 'store/useAppStore';
import { useState } from 'react';
import SimplePDFViewer from './SimplePDFViewer';
import ImageViewerDialog from './ImageViewerDialog';
import checkViewFileType from 'utils/handleViewFile';
import FilePreviewButton from './FilePreviewButton';

const RelatedProjectList = ({ selectedProjectId }) => {
  const userid = useAppStore((state) => state.user.id);
  const company = useAppStore((state) => state.user.company);
  const { currentData, isFetching, isError, refetch } =
    api.endpoints.getRelatedProjectList.useQuery({
      user_id: userid,
      comp_name: company,
      project_id: selectedProjectId,
    });

  const selectedRelatedProject = useAppStore(
    (state) => state.selectedRelatedProject,
  );
  const setter = useAppStore((state) => state.setter);
  const [fileViewer, setFileViewer] = useState({
    open: false,
    file: null,
    type: '',
  });
  const handleViewFile = (blob) => {
    const type = blob.type;
    const checkType = checkViewFileType(type);
    if (checkType === false) {
      return;
    }
    setFileViewer({
      type: checkType,
      open: true,
      file: window.URL.createObjectURL(blob),
    });
  };
  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h6">相關專案列表</Typography>
          {!currentData && isFetching ? (
            <CircularProgress />
          ) : currentData?.project_list.length <= 0 ? (
            <div>無資料</div>
          ) : isError ? (
            <div className="p-2 flex flex-col items-center">
              取得資料發生錯誤
              <Button component="span" onClick={refetch}>
                重試
              </Button>
            </div>
          ) : (
            <div className="flex flex-col gap-6 mt-4">
              {currentData.project_list.map(
                ({ project_id, folder_name, project_name, files }) => {
                  const checked = !!selectedRelatedProject[project_id];
                  return (
                    <Paper
                      key={project_id}
                      variant="outlined"
                      className={cn(
                        'cursor-pointer ',
                        checked && 'outline-blue-500 outline-4',
                      )}
                      onClick={() => {
                        setter('selectedRelatedProject', (draft) => {
                          draft[project_id] = !draft[project_id];
                        });
                      }}
                    >
                      <div className="flex items-center justify-between">
                        <Typography variant="body1" className="p-4">
                          {project_name || folder_name}
                        </Typography>
                        <Checkbox className="mr-[15px]" checked={checked} />
                      </div>
                      <Divider />
                      <div className="p-4 gap-4 flex flex-col">
                        {files.map((fileName) => {
                          return (
                            <div
                              key={`${project_id}:${fileName}`}
                              className="flex items-center justify-between"
                            >
                              <div className="flex">
                                <div className="min-w-0 mr-2">
                                  {fileName.endsWith('.pdf') && (
                                    <PictureAsPdf color="warning" />
                                  )}
                                  {fileName.endsWith('.png') && (
                                    <Image color="primary" />
                                  )}
                                </div>
                                {fileName}
                              </div>
                              <FilePreviewButton
                                projectId={project_id}
                                fileName={fileName}
                                handleViewFile={handleViewFile}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </Paper>
                  );
                },
              )}
            </div>
          )}
        </CardContent>
      </Card>

      <SimplePDFViewer
        open={fileViewer.type === 'pdf' && fileViewer.open}
        file={fileViewer.file}
        onClose={() =>
          setFileViewer(
            produce((draft) => {
              draft.open = false;
            }),
          )
        }
      />
      <ImageViewerDialog
        open={fileViewer.type === 'image' && fileViewer.open}
        file={fileViewer.file}
        onClose={() =>
          setFileViewer(
            produce((draft) => {
              draft.open = false;
            }),
          )
        }
      />
    </>
  );
};
export default RelatedProjectList;
